<template>
<!-- 当类型为附件时 -->

        <div class="mangeannex" style="min-height:32px; overflow-y: auto;">
        <span v-if="!isShowFilelist" style="color:#e98a36">共有{{fileCount}}个附件</span>
            <a href="javascript:void(0)"  @click="handleshow" style="float:right">
              <Icon type="md-arrow-dropdown" :size="28" v-if="!isShowFilelist" ></Icon>
              <Icon type="md-arrow-dropup" :size="28" v-else></Icon>
            </a>
            <div v-show="isShowFilelist">
              <div  v-for="(item , index) in uploadFileList" :key="index" :id="item.id">
                  <div class="file_annex">
                    <div class="insert_edit_input">
                      <Input v-model = "item.description" :disabled="editTable && addOrEdit && 'edit' == addOrEdit" @on-blur="leaveInput($event)" placeholder="请输入附件备注">
                          <Upload ref="upload" :disabled="editTable && addOrEdit && 'edit' == addOrEdit" :action="baseUploadUrl" slot="append" :max-size="15360" :before-upload="((val)=>{handleBeforeUpload(index,val)})" :on-exceeded-size="((val)=>{handleMaxSize(index,val)})" :show-upload-list="false" :on-success="(res,file)=>onSuccess(res,index)" :on-error="uploadFail">
                          <Button icon="ios-cloud-upload" style="color: #3399ff;width:50px"/>
                          </Upload>
                      </Input>
                    </div>
                    <div v-if="index == 0"  @click="addUploadData" class="img_div">
                      <Icon type="ios-add-circle-outline" :size="24"></Icon>

                    </div>
                    <div  v-if="uploadFileList.length != 0" @click="deleteuploadList(item.id,index)" class="img_div">
                      <Icon type="ios-remove-circle-outline" :size="24"></Icon>
                    </div>
                  </div>
              </div>
              <div>
                  <span class="span_must">附件限制15M，备注与附件对应。附件为空，备注失效</span>
              </div>
            </div>

        </div>
</template>
<script>
export default {
    name: "File",
    data(){
        return {
            uploadFileList:[],  //上传文件集合
            baseUploadUrl: this.baseURL+"common/upload.json?type=customerFile&companyNo="+localStorage.getItem("companyId"),
            fileList:[],  //文件集合，用于上传
            isShowFilelist: true,
            fileCount: 0,
          }
    },
    model: {
        prop: 'uploadFileListStr',
        event: 'updateEvent',
    },
    props: {
      uploadFileListStr: String,
      showFilelist: Boolean,
      editTable:Boolean,
      addOrEdit:String
    },
    created(){
        // 这里不加，在添加、编辑共用时，添加页面会没有值
        if (!this.uploadFileListStr || this.uploadFileListStr == undefined || this.uploadFileListStr == "" || JSON.parse(this.uploadFileListStr).length <= 0){
            let file = {
                "description":"",
                "downloadAddr":""
            }
            if(this.uploadFileList.length == 0){
              this.uploadFileList.push(file);
            }
        }else{
          this.uploadFileList = JSON.parse(this.uploadFileListStr);
        }
        this.isShowFilelist = this.showFilelist;
    },
    methods:{
        leaveInput:function(e){
          if(e.target.value){
            this.$emit('changeFile');
          }
        },
        // 附件相关
          handleshow:function () {
           this.isShowFilelist = !this.isShowFilelist;
         },
        addUploadData:function(){//附件中的增加按钮
          if(this.editTable && this.addOrEdit && 'edit' == this.addOrEdit){
            return false;
          }
         if(this.uploadFileList.length>=5){
           this.$Message.info("最多上传5个附件");
           return false;
          }
          let param={
            downloadAddr:"",
            description:""
          };
          this.uploadFileList.push(param);
        },
        deleteuploadList:function(id,index){//附件中的减号按钮
          if(this.editTable && this.addOrEdit && 'edit' == this.addOrEdit){
            return false;
          }
          if(!id && this.uploadFileList.length!=0){
            this.uploadFileList.splice(index,1);
            if(this.uploadFileList.length ==0){
              this.addUploadData();
            }
            let that = this;
            setTimeout(function () {
              that.$emit('changeFile',that.uploadFileList);
            },1000);
          }
        },
        //上传成功
        onSuccess(res, index) {
          this.$Message.success(res.msg);
          this.uploadFileList[index].downloadAddr = res.obj.absolutePath;
          let that = this;
          setTimeout(function () {
            that.$emit('changeFile',that.uploadFileList);
          },1000)
          this.$emit('fileUploadCallback',false);
        },
        //上传失败
        uploadFail(){
          this.$Message.error("上传失败");
          this.$emit('fileUploadCallback',false);
        },
        handleMaxSize (index,file) {
          this.$Modal.info({
            title: '超出文件大小限制',
            content: file.name + '超出文件大小限制，上传文件不能超过15M。'
          });
          this.uploadFileList[index].description = "";
          this.$emit('fileUploadCallback',false);
        },
        handleBeforeUpload(index,file){
          this.fileList.splice(index,1,file);
          if(!this.uploadFileList[index].description){
            this.uploadFileList[index].description = file.name;
          }
          this.$emit('fileUploadCallback',true);
          return true;  //自动上传
        },
        // 父组件调用子组件方法上传附件
        submitFile:function(){
            for (let i = 0; i < this.fileList.length; i++) {
                let item = this.fileList[i]
                this.$refs.upload.post(item);
            }
        },
    },
    watch:{
        uploadFileList: {
            handler(newVal) {
                this.$emit('updateEvent',JSON.stringify(newVal));
                this.uploadFileList = newVal;
            },
            deep: true
        },
        uploadFileListStr:function(){
            if (!this.uploadFileListStr || this.uploadFileListStr == undefined || this.uploadFileListStr == "" || JSON.parse(this.uploadFileListStr).length <= 0){
              this.uploadFileList=[{"description":"","downloadAddr":""}];
            }else{
                this.uploadFileList = JSON.parse(this.uploadFileListStr);
            }
        },
        isShowFilelist:function(){
          if(!this.isShowFilelist){
            for(let i = 0; i < this.uploadFileList.length; i++){
              if(this.uploadFileList[i].downloadAddr){
                this.fileCount++;
              }
            }
          }else{
            this.fileCount = 0;
          }
        }
    }
}
</script>
<style scoped lang="less">
.mangeannex{
  width: 100% !important;
    .file_annex {
        width: 100%;
        height: 44px;
        display: flex;
        .insert_edit_input{
           width: 82%;
          .ivu-upload{
            width: 100%;
            display: flex;

            .ivu-add-list{
              width: 30%;
              height: 44px;
              line-height: 0px;
              white-space: nowrap;
              margin-top: 0px;
              overflow: auto;
            }
            .ivu-upload-list::-webkit-scrollbar-thumb {
              background-color: #2db7f5;
            }
            .ivu-upload-list::-webkit-scrollbar {
              height: 4px;
              width: 4px;
            }
          }
          .ivu-upload-select{
              width: 100%;
          }
          .ivu-input{
            border-radius: 1px;
          }

        }
        .img_div{
          width: 9%;
          line-height: 38px;
          text-align: center;
        }
    }
    .span_must{
      color: #ed4014;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/customerMange/File.vue